import axios from "axios";

export default {
  namespaced: true,
  state: {
    loading: false,
    materiales: [],
    updatedMateriales: new Set(),
    insertedMateriales: new Set(),
    materialesList: [],
    loadingList: false,
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setMaterialesParte(state, materiales) {
      state.materiales = materiales;
    },
    updateMaterialParte(state, { material, isDelete = false }) {
      const index = state.materiales.findIndex((m) => m.id === material.id);

      if (index !== -1) {
        state.materiales.splice(index, 1);
        let insertPending = false;
        //al actualizar, primero comprobamos que no este
        //pendiente de insert. Si es el caso, lo actualizamos ahi
        //en caso de que el "update" sea por un delete, no lo volvemos a insertar
        state.insertedMateriales.forEach((m) => {
          if (m.id === material.id) {
            insertPending = true;
            state.insertedMateriales.delete(m);
          }
        });
        if (insertPending) {
          console.log("inserrt pending", isDelete);
          if (!isDelete) {
            state.insertedMateriales.add(material);
            state.materiales.splice(index, 0, material);
          }
        } else {
          //no estaba pending, actualizamos
          state.updatedMateriales.forEach((m) => {
            if (m.id === material.id) state.updatedMateriales.delete(m);
          });
          state.updatedMateriales.add(material);
          state.materiales.splice(index, 0, material);
        }
      }
    },
    insertMaterialParte(state, material) {
      state.materiales.push(material);
      state.insertedMateriales.add(material);
    },
    setMaterialesList(state, materiales) {
      state.materialesList = materiales;
    },
    setLoadingList(state, loading) {
      state.loadingList = loading;
    },
    resetStore(state) {
      state.materiales = [];
      state.updatedMateriales = new Set();
      state.insertedMateriales = new Set();
    },
  },
  actions: {
    getMateriales({ state, commit }) {
      if (!state.materialesList.length) {
        commit("setLoadingList", true);
        return axios
          .get("/api/materiales")
          .then((res) => {
            commit("setMaterialesList", res.data);
          })
          .finally(() => commit("setLoadingList", false));
      }
    },
    async getMaterialesParte({ commit }, idParte) {
      commit("setLoading", true);
      return axios
        .get(`api/materiales/${idParte}`)
        .then((res) => {
          commit("setMaterialesParte", res.data);
        })
        .finally(() => {
          commit("setLoading", false);
        });
    },
    deleteMaterial({ commit }, material) {
      commit("updateMaterialParte", {
        material: {
          ...material,
          qty: 0,
        },
        isDelete: true,
      });
    },
    updateMaterial({ commit }, material) {
      commit("updateMaterialParte", { material: material });
    },
    insertMaterial({ commit }, material) {
      commit("insertMaterialParte", material);
    },
    resetStore({ commit }) {
      commit("resetStore");
    },
    getMaterialesRequest({ state }) {
      return [...state.insertedMateriales, ...state.updatedMateriales];
    },
  },
  getters: {
    materiales: (state) => state.materiales,
    loading: (state) => state.loading,
    materialesList: (state) => state.materialesList,
    loadingList: (state) => state.loadingList,
  },
};
